import CreateAPaymentLinkModal, { CreateAPaymentLinkModalState } from '.';
import { jsx as _jsx } from "react/jsx-runtime";
const PreEnrollModal = props => {
  return /*#__PURE__*/_jsx(CreateAPaymentLinkModal, Object.assign({}, props, {
    modalState: CreateAPaymentLinkModalState.PRE_ENROLL
  }));
};
export default PreEnrollModal;